import {FormElementValues} from "@xal3xfx/react-utils";

const clientId: FormElementValues<'dropdown'> = {
    type: "dropdown",
    label: 'clientId',
    props: {filterInputAutoFocus: true},
    options: []
}

const date: FormElementValues<'calendar'> = {
    type: "calendar",
    label: 'date',
    props: {},
}

const amount: FormElementValues<'number'> = {
    type: "number",
    label: 'amountWithVat',
    props: {},
}

export const formElements = {
    clientId, date, amount
}
